export enum FileType {
	MP3 = 0,
	WAV = 1,
}
